<template>
  <div class="modal fade" id="DeleteCharge" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-12 my-auto">
            <span><a class="close"><i class="far fa-times-circle fa-2x" data-dismiss="modal" id="closeDeleteCharge"
                  aria-label="Close"></i></a></span>
          </div>
        </div>
        <div class="container-fluid">
          <form @submit.prevent="submit">
            <div class="modal-body">

              <div class="container-fluid">
                <div class="row text-center mt-3">
                  <div class="col-sm-12">
                    <p class="font-weight-bold">Are you sure you want to delete this charge?</p>
                  </div>
                  <div class="col-sm-12 no-pad">
                    <button type="submit" class="btn btn-hc w-40 mr-2 mb-3"
                      :disabled="submitStatus === 'PENDING'">Yes</button>
                    <button type="submit" class="btn btn-hc w-40 ml-2 mb-3" data-dismiss="modal"
                      aria-label="Close">No</button>
                  </div>
                </div>
              </div>

            </div>
          </form>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  data() {
    return {
      submitStatus: null,
    };
  },
  computed: {
    details() {
      return this.$store.state.finances.chargeDetails;
    },
  },
  methods: {
    submit() {
      // do your submit logic here
      this.submitStatus = "PENDING";
      document.getElementById("closeDeleteCharge").click();
      setTimeout(() => {
        this.$http
          .delete(
            "https://" +
              Vue.config.honeycomb.billbot.domain +
              "/api/v1/charges/" +
              this.details.Id,
            {
              Id: this.details.Id,
            },
            {
              withCredentials: true,
            }
          )
          .then(() => {
            // eslint-disable-next-line
            this.submitStatus = "OK";
            this.$snotify.success(`Success! Charge deleted.`);
            this.$store.dispatch("getCharges");
          })
          .catch((error) => {
            // Error
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              this.submitStatus = "Error";
              if (error.response.data.MoreInformation.length > 0) {
                error.response.data.MoreInformation.forEach((e) => {
                  this.$snotify.error(`${e.Error}`, {
                    timeout: 0,
                    closeOnClick: true,
                  });
                });
              } else {
                this.$snotify.error(`${error.response.data.UserDescription}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              }
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              this.submitStatus = "Error";
              this.$snotify.error(`No response recieved.`, {
                timeout: 0,
                closeOnClick: true,
              });
            } else {
              // Something happened in setting up the request that triggered an Error
              this.submitStatus = "Error";
              this.$snotify.error(`${error.message}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          });
      }, 1200);
    },
  },
};
</script>
